module.exports = __webpack_public_path__ + "static/img/theme_05.019fa5d1.png";